const ContentH2 = (props) => {
  return(
    <h2 className="px-4 py-2 font-semibold text-2xl">
      {props.title}
    </h2>
  )
}
export default ContentH2;